import { render } from "./UserAdminGrid.vue?vue&type=template&id=1dc0ab82&scoped=true&ts=true"
import script from "./UserAdminGrid.vue?vue&type=script&lang=ts"
export * from "./UserAdminGrid.vue?vue&type=script&lang=ts"

import "./UserAdminGrid.vue?vue&type=style&index=0&id=1dc0ab82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc0ab82"]])

export default __exports__